import { Pencil1Icon } from "@radix-ui/react-icons";
import { XIcon } from "lucide-react";

import { theme } from "@/components/canvas-editor/components/Container";
import { SavedTag } from "@/lib/types";
import { cn } from "@/lib/utils";

export function TagListItem({
  tag,
  onDelete,
  onEdit,
  ...props
}: {
  tag: SavedTag;
  onDelete?: () => void;
  onEdit?: () => void;
}) {
  return (
    <div
      {...props}
      className={cn(
        "flex gap-1 items-center",
        "w-fit rounded-lg pl-1.5 py-1 text-xs border font-mono",
        onDelete ? "pr-0.5" : "pr-1.5",
        theme.surface[tag.color === "slate" ? "default" : tag.color],
        theme.text[tag.color === "slate" ? "default" : tag.color],
      )}
    >
      {tag.display_name}
      {(onDelete || onEdit) && (
        <div className="flex gap-0.5">
          {onEdit && (
            <button
              type="button"
              onClick={onEdit}
              className="bg-slatea-ghost rounded-full p-1"
            >
              <span className="sr-only">Edit Tag</span>
              <Pencil1Icon className="w-3 h-3" />
            </button>
          )}
          {onDelete && (
            <button
              type="button"
              onClick={onDelete}
              className="bg-slatea-ghost rounded-full p-1"
            >
              <span className="sr-only">Delete Tag</span>
              <XIcon className="w-3 h-3" />
            </button>
          )}
        </div>
      )}
    </div>
  );
}
